const LOAN_PURPOSE_MAP = {
  Bil: "Vehicle",
  Båt: "Vehicle",
  MC: "Vehicle",
  Bodelning: "Other",
  "Bostad - inredning": "Renovation",
  "Bostad - renovering": "Renovation",
  Bouppteckning: "Other",
  Bröllop: "Special occasion",
  Inkassoskuld: "Other",
  "Inv. i eget företag": "Investment",
  Investering: "Investment",
  Konsumtion: "Other",
  Körkort: "Other",
  "Resor/nöjen": "Holiday",
  "Samla lån": "Refinancing loan",
  "Sjukvård/Operation": "Unexpected expenses",
  Studier: "Other",
};

const specialLinksLoans = {
  "/lanebelopp/lana-10000/": 10000,
  "/lanebelopp/lana-50000/": 50000,
  "/lanebelopp/lana-100000/": 100000,
  "/lanebelopp/lana-200000/": 200000,
  "/lanebelopp/lana-400000/": 400000,
  "/lanebelopp/lana-500000/": 500000,
  "/lanebelopp/lana-600000/": 600000,
};

const INTEREST_RATE = 0.0591;
const STARTUP_FEE = 495;
const MONTHLY_FEE = 0;
const RATES = {
  LOW: 7.9,
  MID: 12,
  HIGH: 16,
};

export {
  LOAN_PURPOSE_MAP,
  specialLinksLoans,
  INTEREST_RATE,
  STARTUP_FEE,
  RATES,
  MONTHLY_FEE,
};
